import { render, staticRenderFns } from "./ModalShipmentCancel.vue?vue&type=template&id=d702afdc&"
import script from "./ModalShipmentCancel.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports